import ScrollReveal from "./ScrollReveal";
import { usePublicLang } from "@/contexts/PublicLangContext";
import { LANDING } from "@/constants/testIds";

export default function IntroSection({ landing }) {
  const { t } = usePublicLang();
  if (!landing.intro_text) return null;

  return (
    <section className="py-20 md:py-28 px-5" data-testid={LANDING.intro}>
      <ScrollReveal className="max-w-2xl mx-auto text-center flex flex-col gap-5">
        <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-[#292522]">
          {landing.intro_title || t("landing.intro.defaultTitle")}
        </h2>
        <p className="text-base md:text-lg leading-relaxed text-[#6B6058] whitespace-pre-line">
          {landing.intro_text}
        </p>
      </ScrollReveal>
    </section>
  );
}
